import React, { useEffect, useState } from 'react';
import { useParams  } from "react-router-dom";
import helpers from '../../../services/helpers';
import { httpRequest } from '../../../services/httpService';
import Swal from 'sweetalert2';
import Loader from '../../parts/Loader';
import store from '../../../services/store';
import images from '../../../services/images';
import initTreeView from '../../../services/initTreeView';
import StoreInfo from '../../parts/StoreInfo';
import { getApiData } from '../../../services/apiService';
import { serviceRequestData } from '../../../services/serviceHubStore';

export default function ServiceRequestSOAPrintView (){
    const { service_request_id } = useParams();
    const [loading, setLoading] = useState(1);
    const [record_loaded, setRecordLoaded] = useState(0);
    const [record_data, setRecordData] = useState([]);
    const [record_items, setRecordItems] = useState([]);
    const [table_items, setTableItems] = useState([]);
    const [load_status, setStatus] = useState(0);
    const [account, setAccount] = useState([]);
   
    useEffect(() => {
        initTreeView()
        
        const customer_id = helpers.getURLParams('customer_id');
        const request_from = helpers.getURLParams('request_from');
        const request_to = helpers.getURLParams('request_to');
        if(customer_id && request_from && request_to){
            fetchAccount()
        }
    }, []);

    useEffect(() => {
        if(load_status){
            setTimeout(function(){
                //window.print()
            }, 2000);
        }
    }, [load_status]);

    useEffect(() => {
        displayTableItems()
    }, [record_items]);

    async function fetchAccount(){
        let endpoint = helpers.createUrl(`V1/account/profile`)
        const res = await getApiData(endpoint)

        if(res){
            setAccount(res.data)
            //setAccountLoaded(1)
            
            fetchData()
        }
                
        if(res.status === 'error'){
            setLoading(0)
            Swal.fire({
                text: res.message,
                icon: "error",
                confirmButtonText: "OK",
                allowOutsideClick: false
            })
            .then((result) => {
                if (result.isConfirmed) {
                    window.location.replace("/customers/list");
                }
            })
        }
    }


    async function fetchData(){
        const customer_id = helpers.getURLParams('customer_id');
        const request_from = helpers.getURLParams('request_from');
        const request_to = helpers.getURLParams('request_to');

        const param_keys = {
            customer_id: customer_id,
            request_from: request_from,
            request_to: request_to
        }

        const params = helpers.generateUrlParams(param_keys)

        let endpoint = helpers.createServiceHubUrl(`v1/service-requests/soa/${params}`)
        const res = await getApiData(endpoint, false)

        if(res){
            console.log(res)
            setLoading(0)
            setRecordData(res)
            setRecordItems(res.service_items)
        }
                
        if(res.status === 'error'){
            setLoading(0)
            Swal.fire({
                text: res.message,
                icon: "error",
                confirmButtonText: "OK",
                allowOutsideClick: false
            })
            .then((result) => {
                if (result.isConfirmed) {
                    window.location.replace("/customers/list");
                }
            })
        }
    }

    function displayTableItems(){
        let items = []
        
        if (record_items?.length) {
            items = Object.entries(record_items).map(([key, data]) => {
                let counter = parseInt(key) + 1
                return(
                    <>
                        <tr>
                            <td>{counter}</td>
                            <td>{data?.brand}</td>
                            <td>{data?.model ? data.model : 'N/A'}</td>
                            {/* <td>{data?.indoor_serial ? data.indoor_serial : 'N/A'}</td>
                            <td>{data?.outdoor_serial ? data.outdoor_serial : 'N/A'}</td> */}
                            <td>{data?.qr_code}</td>
                            <td>{data?.service_no ? data.service_no : 'N/A'}</td>
                            <td>{data?.request_date ? data.request_date : 'N/A'}</td>
                            <td>
                                <input type="text" value="1" className='form-control form-control-sm'/>
                            </td>
                            <td>
                                <input type="text" className='form-control form-control-sm'/>
                            </td>
                            <td>
                                <input type="text" className='form-control form-control-sm'/>
                            </td>
                        </tr>
                    
                        <tr>
                        </tr>
                    </>
                )
            })

            items.push(
                <tr>
                    <th className='bg-light text-right' colSpan={6}>TOTAL</th>
                    <th className='bg-light'>
                        <input type="text" className='form-control form-control-sm' value={record_items?.length}/>
                    </th>
                    <th className='bg-light'>
                        <input type="text" className='form-control form-control-sm'/>
                    </th>
                    <th className='bg-light'>
                    <input type="text" className='form-control form-control-sm'/>
                    </th>
                </tr>
            )
        }
        else{
            items =  
                    <tr>
                        <td colSpan={10} className='text-center'>No data to display.</td>
                    </tr>
        }


        setTableItems(<tbody>{items}</tbody>)
        setStatus(1)
    }

    function computeSubTotals(){
        let items = 0;
        let total_amount = 0
        Object.entries(record_items).map(([key, data]) => {
            items = items + Number(data.quantity)
            total_amount = total_amount + parseInt(data.quantity) * parseFloat(data.amount)
        });

        return helpers.formatCurrencyAmount(total_amount);
    }


    return (
        <div className="invoice p-4 mb-3">
            <Loader isLoading={loading}/>

            
            <div className="mx-auto d-flexs justify-content-betweens">
                <img src={images.main_logo} height={80} className='float-left mr-3' />
                <div>
                    <p className='mb-0'><b>Polar-Air Aircon</b></p>
                    <p className='mb-0'>Matias Building, National Highway, Isulan, Sultan Kudarat 9805</p>
                    <p className='mb-0'>0953-685-7478</p>
                </div>
            </div>

            <hr/>
            
            <h5 className='text-center'><strong>STATEMENT OF ACCOUNT</strong></h5>

            <div className="d-flex justify-content-between mb-3">
                <div>
                    <p className='mb-0'>Customer: <b>{record_data?.customer?.contact_name ? record_data?.customer?.contact_name : 'N/A'}</b></p>
                    {/* <p className='mb-0'>Address: {helpers.concatenateText([record_data?.customer?.address_1, record_data?.customer?.address_2, record_data?.customer?.city, record_data?.customer?.province], ', ')}</p> */}
                    {/* <p className='mb-0'>{record_data.phone_no ? record_data.phone_no : 'N/A'}</p> */}
                    <p>Service Date: <b>{`${helpers.getURLParams('request_from')} to ${helpers.getURLParams('request_to')}`}</b></p>
                </div>
                <div>
                    <p className='mb-0'>Generated Date: <b>{helpers.getCurrentDate()}</b></p>
                </div>
            </div>

            <div className='table-responsives'>
                <table className='table table-bordered table-stripeds table-sm border-bottom'>
                    <thead class="thead-dark">
                        <tr>
                            <th>NO.</th>
                            <th>BRAND</th>
                            <th>MODEL</th>
                            {/* <th>INDOOR SERIAL</th>
                            <th>OUTDOOR SERIAL</th> */}
                            <th>QR&nbsp;CODE</th>
                            <th>SERVICE&nbsp;NO</th>
                            <th>SERVICE&nbsp;DATE</th>
                            <th>QTY</th>
                            <th>UNIT PRICE ({helpers.getSettingValue(account?.settings, 'default_currency', 'PHP')})</th>
                            <th>TOTAL ({helpers.getSettingValue(account?.settings, 'default_currency', 'PHP')})</th>
                        </tr>
                    </thead>
                    {
                        table_items
                    }
                </table>
            </div>

            <div className="row border-top mt-5">
                <div className="col-12 text-center">
                    <small>Powered By Topventory Sales &amp; Inventory Solutions</small>
                </div>
            </div>
        </div>
    )
}